// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendarViewSwitcher {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 15px;
    gap: 20px;
}

.calendarViewSwitcher_navigation {
    display: flex;
    align-items: center;
    gap: 10px;
}

.calendarViewSwitcher_nav_button {
    width: 32px;
    height: 32px;
    border: 1px solid #e0e0e0;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #666;
}

.calendarViewSwitcher_nav_button:hover {
    background: #f5f5f5;
    border-color: #ccc;
}

.calendarViewSwitcher_today_button {
    padding: 6px 12px;
    border: 1px solid #e0e0e0;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
}

.calendarViewSwitcher_today_button:hover {
    background: #f5f5f5;
    border-color: #ccc;
}

.calendarViewSwitcher_views {
    position: absolute;
    right: 50px;
    display: flex;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
}

.calendarViewSwitcher_view_button {
    padding: 8px 16px;
    border: none;
    background: white;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    border-right: 1px solid #e0e0e0;
}

.calendarViewSwitcher_view_button:last-child {
    border-right: none;
}

.calendarViewSwitcher_view_button:hover {
    background: #f5f5f5;
}

.calendarViewSwitcher_view_button.active {
    background: #007bff;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/calendarGrid/CalendarViewSwitcher.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".calendarViewSwitcher {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #e0e0e0;\n    margin-bottom: 15px;\n    gap: 20px;\n}\n\n.calendarViewSwitcher_navigation {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.calendarViewSwitcher_nav_button {\n    width: 32px;\n    height: 32px;\n    border: 1px solid #e0e0e0;\n    background: white;\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    color: #666;\n}\n\n.calendarViewSwitcher_nav_button:hover {\n    background: #f5f5f5;\n    border-color: #ccc;\n}\n\n.calendarViewSwitcher_today_button {\n    padding: 6px 12px;\n    border: 1px solid #e0e0e0;\n    background: white;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #333;\n}\n\n.calendarViewSwitcher_today_button:hover {\n    background: #f5f5f5;\n    border-color: #ccc;\n}\n\n.calendarViewSwitcher_views {\n    position: absolute;\n    right: 50px;\n    display: flex;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.calendarViewSwitcher_view_button {\n    padding: 8px 16px;\n    border: none;\n    background: white;\n    cursor: pointer;\n    font-size: 14px;\n    color: #666;\n    border-right: 1px solid #e0e0e0;\n}\n\n.calendarViewSwitcher_view_button:last-child {\n    border-right: none;\n}\n\n.calendarViewSwitcher_view_button:hover {\n    background: #f5f5f5;\n}\n\n.calendarViewSwitcher_view_button.active {\n    background: #007bff;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
